import { render, staticRenderFns } from "./homePart1.vue?vue&type=template&id=bd500a5e&scoped=true&"
import script from "./homePart1.vue?vue&type=script&lang=js&"
export * from "./homePart1.vue?vue&type=script&lang=js&"
import style0 from "./homePart1.vue?vue&type=style&index=0&id=bd500a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd500a5e",
  null
  
)

export default component.exports